export default __webpack_public_path__ + "static/assets/d17af710c766436e3cceb28948d5efbc.jpg";